import { Check, ShieldCheck } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const POINTS = [
  "Built for UK subcontractors — automatic CIS deductions and VAT reverse charge",
  "Pay by card or bank transfer — clients choose whichever suits them",
  "Money goes straight to you — card payments land in your own bank, usually next day",
  "Fair, upfront pricing — a small 0.5% fee on card payments; bank transfers are always free (standard Stripe processing fees apply)",
  "Live status from Sent → Viewed → Approved → Paid",
];

const STATUSES = ["Sent", "Viewed", "Approved", "Paid"];

export const GetPaidSection = () => {
  return (
    <section
      id="get-paid"
      data-testid="get-paid-section"
      className="py-20 md:py-28 bg-brand-navy-deep text-white"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10 lg:px-16">
        <Reveal className="max-w-3xl">
          <p className="text-xs font-semibold tracking-[0.2em] uppercase text-brand-sky">
            Payments
          </p>
          <h2 className="mt-4 font-heading font-700 text-3xl sm:text-4xl lg:text-5xl tracking-tight text-white">
            Send it. Get paid. No chasing.
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-slate-300">
            Turn your progress billing into a professional Application for
            Payment and share it with a single link. Your client can view it,
            approve it and pay — all in one place, from any browser, no login
            required.
          </p>
        </Reveal>

        <Reveal delay={0.08}>
          <div className="mt-10 flex flex-wrap items-center gap-2">
            {STATUSES.map((s, i) => (
              <div key={s} className="flex items-center gap-2">
                <span
                  data-testid={`payment-status-${s.toLowerCase()}`}
                  className="rounded-full bg-white/10 px-4 py-1.5 text-sm font-medium text-white"
                >
                  {s}
                </span>
                {i < STATUSES.length - 1 && (
                  <span className="text-brand-sky">→</span>
                )}
              </div>
            ))}
          </div>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-4">
          {POINTS.map((p, i) => (
            <Reveal key={i} delay={i * 0.06}>
              <div
                data-testid={`payment-point-${i}`}
                className="flex items-start gap-3 rounded-xl border border-white/10 bg-white/5 p-5 h-full"
              >
                <span className="mt-0.5 inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-brand-sky/20 text-brand-sky">
                  <Check className="h-4 w-4" strokeWidth={2.5} />
                </span>
                <span className="text-sm leading-relaxed text-slate-200">
                  {p}
                </span>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-8 flex items-center gap-3 rounded-xl bg-white/5 border border-white/10 px-5 py-4">
            <ShieldCheck className="h-5 w-5 shrink-0 text-brand-sky" />
            <p className="text-sm text-slate-300">
              Blue Shuck never holds your money — payments settle straight to
              your own Stripe account.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
